import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-normas-institucionales',
  templateUrl: './normas-institucionales.component.html',
  styleUrls: ['./normas-institucionales.component.css']
})
export class NormasInstitucionalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
